import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=8a565d2a&"
import script from "./EditVideo.vue?vue&type=script&lang=ts&"
export * from "./EditVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports